











import { Component, Prop, Vue } from 'vue-property-decorator'
import IconWarningCircle from '@/app/ui/assets/icon_warning_circle.vue'

@Component({
  name: 'Note',
  components: {
    IconWarningCircle,
  },
})
export default class Modal extends Vue {
  @Prop({ default: 'give me a note' }) private text!: string
}
